import React, { useEffect, useState } from 'react';
import { Input, Button, Dropdown, List, Select, Icon } from 'tea-component';
import './index.scss';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { buriedBtnPoint } from '@/pages/opinion/operationLog/buriedPoint';
import { NO_DATE } from '@/pages/opinion/constants';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { compareOptionList, compareStepMap } from '@op/constants/specialOptions';

const scoreFilterOptions = [
  { symbol: '<', value: '_score', text: 'Score Value' },
  {
    symbol: '<',
    value: '_compareScore',
    text: 'Score Change',
  },
  {
    symbol: '<',
    value: '_rationPercent',
    text: 'Score Change%',
    isPercent: true,
  },
];

export default function ScoreFilterSelect({
  scoreFilterChange,
  options = scoreFilterOptions,
}: {
  scoreFilterChange: any;
  options?: Array<{
    symbol: string;
    value: string;
    text: string;
    isPercent?: boolean;
  }>;
}) {
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailPercent, setOpenDetailPercent] = useState(false);
  const { formatMessage, formatOptionsMessage } = useLanguage();
  const [scoreStep0, setScoreStep0] = useState('');
  const [scoreStep1, setScoreStep1] = useState('');
  const [scoreStep2, setScoreStep2] = useState<any>('');
  const [inputError, setInputError] = useState(false);
  const [showClear, setshowClear] = useState(false);

  const optionsTextMap = arrayToSimpleObj(options, 'text', 'value');
 

  const checkInput = (close: any) => {
    if (scoreStep2 == '') {
      setInputError(true);
    } else {
      close();
      setTimeout(() => {
        const st2 = Number(scoreStep2);
        setOpenDetail(false);
        setOpenDetailPercent(false);
        scoreFilterChange({
          valueKey: scoreStep0,
          symbolValue: scoreStep1,
          value: isNaN(st2) ? 0 : st2,
        });
      }, 600);
    }
  };

  useEffect(() => {
    if (scoreStep2 != '') {
      setInputError(false);
    }
  }, [scoreStep2]);

  return (
    <div className="dbo-scorefilter">
      <Dropdown
        button={
          <div className="dbo-scorefilter-inner">
            <span className="select-button-text">
              {formatMessage({ id: 'Score Filter' })}
            </span>
            <span
              className="dbo-scorefilter-value"
              onMouseEnter={() => {
                if (scoreStep0 != '' || scoreStep1 != '' || scoreStep2 != '') {
                  setshowClear(true);
                }
              }}
              onMouseLeave={() => {
                setshowClear(false);
              }}
            >
              <span className="dbo-scorefilter-value-inner">
                <span>
                  {formatMessage({
                    id: optionsTextMap[scoreStep0] || NO_DATE.EMPTY,
                  })}
                </span>
                &nbsp;
                <span>{compareStepMap[scoreStep1]}</span>
                <span>
                  {scoreStep2}
                  {openDetailPercent && scoreStep2 ? '%' : ''}
                </span>
              </span>

              {showClear ? (
                <Icon
                  className="dbo-scorefilter-dismiss"
                  type="dismiss"
                  onClick={(e: any) => {
                    e?.stopPropagation();
                    setScoreStep0('');
                    setScoreStep1('');
                    setScoreStep2('');
                    scoreFilterChange(null);
                    setshowClear(false);
                  }}
                />
              ) : null}
            </span>
          </div>
        }
        appearance="button"
        matchButtonWidth
        clickClose={false}
        onOpen={() => {
          buriedBtnPoint('G_ScoreFilter');
        }}
      >
        {(close) => (
          <>
            {openDetail ? (
              <div className="dbo-scorefilter-dropdown">
                <Select
                  className="select-item"
                  appearance="button"
                  matchButtonWidth
                  defaultValue={'less'}
                  options={formatOptionsMessage(compareOptionList)}
                  value={scoreStep1}
                  onChange={(value) => setScoreStep1(value)}
                />
                <div
                  className={`dbo-scorefilter-dropdown-input ${
                    openDetailPercent ? 'dropdown-input-percent' : ''
                  } ${inputError ? 'error' : ''}`}
                >
                  <Input
                    value={scoreStep2}
                    onChange={(value) => setScoreStep2(value)}
                    type="number"
                    placeholder={formatMessage({ id: 'Input Number' })}
                  />
                  {openDetailPercent ? (
                    <div className="dbo-scorefilter-dropdown-percent">%</div>
                  ) : null}
                </div>
                {inputError ? (
                  <span className="text-error">
                    {formatMessage({ id: "Can't be null" })}
                  </span>
                ) : null}
                <div className="dbo-scorefilter-dropdown-btngroup">
                  <Button
                    type="primary"
                    onClick={() => {
                      checkInput(close);
                    }}
                  >
                    {formatMessage({ id: 'Confirm' })}
                  </Button>
                  <Button
                    type="weak"
                    onClick={() => {
                      setOpenDetail(false);
                      setOpenDetailPercent(false);
                    }}
                  >
                    {formatMessage({ id: 'Back' })}
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <List type="option">
                  {options.map(({ symbol, value, text, isPercent = false }) => (
                    <List.Item
                      onClick={() => {
                        setOpenDetail(true);
                        setScoreStep1(symbol);
                        setScoreStep0(value);
                        setOpenDetailPercent(isPercent);
                      }}
                    >
                      {formatMessage({ id: text })}
                    </List.Item>
                  ))}
                </List>
              </>
            )}
          </>
        )}
      </Dropdown>
    </div>
  );
}
